import { FALLBACK_LANGUAGE_CODE, normalizeLanguageCode } from './constants';

export const LOCAL_LANGUAGE_KEY = 'mention.language';

export function getStoredLanguage() {
  try {
    return normalizeLanguageCode(localStorage.getItem(LOCAL_LANGUAGE_KEY));
  } catch {
    return null;
  }
}

export function storeLanguage(language) {
  const normalizedLanguage = normalizeLanguageCode(language);

  if (!normalizedLanguage) {
    return;
  }

  try {
    localStorage.setItem(LOCAL_LANGUAGE_KEY, normalizedLanguage);
  } catch {
    // Storage can be unavailable in private browsing or embedded contexts.
  }
}

export function removeStoredLanguage() {
  try {
    localStorage.removeItem(LOCAL_LANGUAGE_KEY);
  } catch {
    // Storage can be unavailable in private browsing or embedded contexts.
  }
}

export function getBrowserLanguage() {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const browserLanguages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];

  for (const language of browserLanguages) {
    const normalizedLanguage = normalizeLanguageCode(language);
    if (normalizedLanguage) {
      return normalizedLanguage;
    }
  }

  return null;
}

export function getInitialLanguage() {
  return getStoredLanguage() || getBrowserLanguage() || FALLBACK_LANGUAGE_CODE;
}
